<template>
	<div class="preview z-flex z-flex-center" v-if="showPreview">
		<img class="img" :src="imgList[index]" />
		<div class="btn-page prev z-flex z-flex-center" @click="prev"><i class="el-icon-arrow-left"></i></div>
		<div class="btn-page next z-flex z-flex-center" @click="next"><i class="el-icon-arrow-right"></i></div>
		<div class="close z-flex z-flex-center" @click="showPreview=false"><i class="el-icon-close"></i></div>
	</div>
</template>

<script>
export default {
  name: 'previewImg',
  props: {
	imgList:{
		type: [Array, Object],
		default: []
	},
  },
  data () {
    return {
		index:0,
		showPreview:false,
    }
  },
  methods: {
	prev(){
		if(this.index==0){
			return this.$message('当前已经是第一张图片');
		}
		this.index--
		
	},
	next(){
		if(this.index==this.imgList.length-1){
			return this.$message('当前已经是最后一张图片');
		}
		this.index++
	}
  },
}
</script>

<style lang="scss" scoped>
	.preview{
		width:100vw;
		height:100vh;
		background:rgba(0,0,0,.6);
		position:fixed;
		left:0;
		top: 0;
		z-index: 1000;
		.img{
			max-width: 90%;
			max-height: 90%;
		}
		.btn-page,.close{
			width: 60px;
			height: 60px;
			border-radius: 100%;
			font-size: 36px;
			color: #fff;
			background-color: rgba(0,0,0,.3);
			cursor: pointer;
			position: absolute;
			top: 50%;
			margin-top:-30px;
		}
		.btn-page:hover,.close:hover{
			background-color: rgba(0,0,0,.5);
		}
		.prev{
			left:20px;
		}
		.next{
			right:20px;
		}
		.close{
			top: 20px;
			right:20px;
			margin-top:0;
		}
	}
</style>
